





































































import { Component, Vue } from 'vue-property-decorator';
import HeaderComponent from '@/ui-components/header/HeaderComponent.vue';
import { retrieveCatalogSessionList } from '@/services/catalog/api';
import { CatalogSessionListRequest, CatalogSession } from '@/Model/sessions/catalogTypes';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { ScreenText } from '@/lang/ScreenText';

@Component({
  components: {
    HeaderComponent,
  }
})
export default class SessionDetail extends Vue {
  public session: CatalogSession = {} as CatalogSession;
  public readonly screenText = new ScreenText();

  get startDate(): string {
    return APP_UTILITIES.formatLongDateFromDateTime(this.session.startDateTime);
  }

  get endDate(): string {
    return APP_UTILITIES.formatLongDateFromDateTime(this.session.endDateTime);
  }


  get days(): string {
    if (this.session.selectedDays) {
      const abbrMap = new Map(
        APP_UTILITIES.getDaysAbbreviations(false).map(e => [e.day, e.abbreviation])
      );
      return this.session.selectedDays.map(e => abbrMap.get(e)).join(', ');
    }
    return '';
  }

  get startTime(): string {
    return APP_UTILITIES.format12HrTimeFromDateTime(this.session.startDateTime, true);
  }

  get endTime(): string {
    return APP_UTILITIES.format12HrTimeFromDateTime(this.session.endDateTime, true);
  }

  public navigateBack() {
    this.$router.go(-1);
  }

  public async mounted() {
    const design: any = JSON.parse(APP_UTILITIES.getCookie('accountDesign') || '');
    const accountId = design.accountId;
    const catalogListRequest: CatalogSessionListRequest = {
      accountId: accountId,
      sessionIdList: [Number(this.$route.params.sessionId)],
      page: 1,
      count: 0
    };
    const response = await retrieveCatalogSessionList(catalogListRequest);

    console.log(response);
    if (response && response.data && response.data.results && response.data.results.length > 0) {
      this.session =  response.data.results[0];
    }
  }
}
